var module = angular.module('octopusApp.projects');

module.controller('ChannelEditController', function ($scope, busy, $stateParams, projectState, $location, $uibModal, $q,
                                                     pageTitle, octopusRepository, unsavedChanges) {

    var channelId = $stateParams.channelId;
    var projectId = $stateParams.projectId;
    var isLoading = projectState.isLoading;
    var isSaving = $scope.isSaving = busy.create();

    $scope.actionsByName = {};

    if (!channelId) {
        $scope.model = {
            IsDefault: false,
            Rules: []
        };
    }

    function init() {
        var promises = [];
        promises.push(projectState.load()
            .then(function (project) {
                $scope.project = project;
                return projectState.deploymentProcessAsync;
            })
            .then(function (deploymentProcess) {
                $scope.actions = _.chain(deploymentProcess.Steps)
                    .map(function (step) {
                        return step.Actions;
                    })
                    .flatten()
                    .filter(function (action) {
                        return action.Properties['Octopus.Action.Package.PackageId'];
                    })
                    .value();
                $scope.actionsByName = _.object(_.pluck($scope.actions, "Name"), $scope.actions);
            }));

        promises.push(octopusRepository.Lifecycles.all().then(function (lifecycles) {
            $scope.lifecycles = lifecycles;
        }));

        isLoading.promises(promises).then(function () {
            if (channelId) {
                isLoading.promise(octopusRepository.Channels.get(channelId)).then(function (channel) {
                    $scope.model = channel;
                });
            }
        });
    }

    $scope.save = function () {
        $scope.model.ProjectId = $scope.project.Id;
        isSaving.promise(octopusRepository.Channels.save($scope.model).then(function () {
            unsavedChanges.saved();
            $location.path('/projects/' + $scope.project.Slug + '/channels');
        }));
    };

    $scope.design = function (rule) {
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/channels/design_rule_dialog.html',
            controller: 'ChannelDesignRuleController',
            resolve: {
                rule: function () {
                    return {versionRange: rule.VersionRange, tag: rule.Tag};
                },
                samplePackages: function () {
                    if (!rule.Actions) {
                        return [];
                    }
                    return $q.all(rule.Actions
                        .map(function (actionName) {
                            var action = $scope.actionsByName[actionName];
                            var feedId = action.Properties["Octopus.Action.Package.FeedId"];
                            var searchOptions = {
                                packageId: action.Properties["Octopus.Action.Package.PackageId"],
                                partialMatch: false,
                                includeMultipleVersions: true,
                                includePreRelease: true,
                                includeNotes: false,
                                take: 5
                            };
                            return octopusRepository.Feeds.get(feedId).then(function (feed) {
                                return octopusRepository.Feeds.search(feed, searchOptions);
                            }).then(function (results) {
                                return results.map(function (package) {
                                    return package.Version;
                                });
                            });
                        })).then(function (results) {
                        return _.union.apply(_, results);
                    });
                }
            }
        }).result.then(function (result) {
            if (!result) {
                return;
            }
            rule.VersionRange = result.versionRange;
            rule.Tag = result.tag;
        });
    };

    $scope.addVersionRule = function () {
        unsavedChanges.unsaved();
        $scope.model.Rules.push({
            Actions: []
        });
    };


    $scope.removeVersionRule = function (rule) {
        unsavedChanges.unsaved();
        var ix = $scope.model.Rules.indexOf(rule);
        if (ix >= 0) {
            $scope.model.Rules.splice(ix, 1);
        }
    };

    $scope.removeRuleStep = function (rule, stepName) {
        rule.Actions.splice(rule.Actions.indexOf(stepName), 1);
        unsavedChanges.unsaved();
    };

    $scope.addAction = function (rule) {

        var alreadySelectedActions = _.flatten($scope.model.Rules.map(function (a) {
            return a.Actions;
        }));

        var candidateActions = $scope.actions
            .filter(function (action) {
                return (alreadySelectedActions.indexOf(action.Name) === -1);
            });

        if (candidateActions.length === 1) {
            addRuleStep(rule, candidateActions[0].Name);
        } else {
            $uibModal.open({
                backdrop: true,
                keyboard: true,
                templateUrl: 'areas/projects/channels/add_step_dialog.html',
                controller: 'ChannelAddStepController',
                resolve: {
                    steps: function () {
                        return candidateActions;
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    addRuleStep(rule, result);
                }
            });
        }
    };

    function addRuleStep(rule, stepName) {
        rule.Actions.push(stepName);
        unsavedChanges.unsaved();
    }


    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/channels/channel_edit_controller.js
// module id = 507
// module chunks = 1